// src/pages/auth/ValidateEmail.js
import React, { useEffect, useState } from 'react';
import { Box, Alert, Button } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import createAuthService from '../../utils/AuthService';
import { useAppContext } from '../../contexts/AppContext';
import { useLanguage } from '../../contexts/LanguageContext'; // ✅ import language

function ValidateEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { updateAppState } = useAppContext();
  const { translations } = useLanguage(); // ✅ translations

  const authService = createAuthService();
  const [status, setStatus] = useState('loading');

  const validateToken = async () => {
    const token = searchParams.get('token');
    if (token) {
      var response = await authService.validateEmailToken(token);
      
    if (response.status !== 200) {
      setStatus('error');
      return;
    }
      // set status to success before redirecting,
    updateAppState({
      isAuthenticated: true,
      accessToken: response.data.accessToken,
        refreshToken: response.data.refreshToken
    });

      var meResponse = await authService.meAsync(response.data.accessToken);
      updateAppState({ user: meResponse.data });

    setStatus('success');

    }
  };

  useEffect(() => {
    validateToken();
  }, []);
  return (
    <Box
      sx={{
        maxWidth: 400,
        margin: 'auto',
        mt: 10,
        p: 3,
        boxShadow: 3,
        textAlign: 'center',
      }}
    >
      {status === 'success' && (
        <>
          <Alert severity="success">{translations.auth_pages.email_verified_success}</Alert>
          <Button variant="contained" sx={{ mt: 2 }} onClick={() => navigate('/store-creation')}>
            {translations.auth_pages.proceed_to_next_step}
          </Button>
        </>
      )}

      {status === 'error' && (
        <>
          <Alert severity="error">{translations.auth_pages.email_verification_failed}</Alert>
          <Button variant="contained" sx={{ mt: 2 }} onClick={() => navigate('/signup')}>
            {translations.auth_pages.sign_up_again}
          </Button>
        </>
      )}
    </Box>
  );
}

export default ValidateEmail;
